module.exports = __webpack_public_path__ + "media/evolve/assets/icons/static/logout-63af19ee7dd812e114876025d2093e28.svg";